import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BOOKING_URL, NAV_LINKS } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const tickerText =
    "HAMMAM MEN'S SPA RAJOURI GARDEN BRANCH OPEN • NEAR RAJOURI GARDEN METRO • INDIA'S BEST MALE TO MALE SPA & WELLNESS GROUP • PREMIUM GAY SPA IN NEW DELHI • BOOK YOUR IN-SPA OR DOORSTEP SESSION ONLINE • EXPERIENCE LUXURY MALE GROOMING & REJUVENATION";

  return (
    <header className="sticky top-0 z-40">
      {/* Moving Marquee Ticker Banner */}
      <div
        data-testid="announcement-bar"
        className="bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 text-black text-xs sm:text-sm font-extrabold py-2 overflow-hidden whitespace-nowrap shadow-md relative"
      >
        <div className="flex gap-12 animate-top-marquee w-max">
          <span>{tickerText} &nbsp;&bull;&nbsp;</span>
          <span>{tickerText} &nbsp;&bull;&nbsp;</span>
        </div>
        <style>{`
          .animate-top-marquee {
            animation: top-marquee 30s linear infinite;
          }
          @keyframes top-marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>

      <nav className="backdrop-blur-xl bg-[#080808]/80 border-b border-white/10 py-3.5 px-4 sm:px-8 lg:px-12 flex justify-between items-center">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3 text-white group"
        >
          <img src="/logo192.png" alt="Hammam Men's Spa" className="w-10 h-10 object-contain rounded-full border border-amber-400/50 shadow-md group-hover:scale-105 transition-transform" />
          <span className="font-serif text-xl sm:text-2xl font-black tracking-tight">
            Hammam <span className="text-amber-400">Men's Spa</span>
          </span>
        </Link>
        <div className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.href}
              to={l.href}
              end={l.href === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-300 ${
                  isActive
                    ? "text-amber-400 font-bold border-b-2 border-amber-400 pb-0.5"
                    : "text-white/70 hover:text-amber-400"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-book-session-btn"
            className="hidden sm:inline-block bg-gradient-to-r from-amber-300 to-amber-600 text-black px-6 py-2.5 rounded-full text-xs font-bold uppercase tracking-[0.2em] hover:shadow-[0_0_15px_rgba(245,158,11,0.4)] transition-all duration-300"
          >
            Book Session
          </a>
          <button
            data-testid="nav-mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-1"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </nav>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden backdrop-blur-xl bg-[#080808]/95 border-b border-white/10 px-4 py-6 flex flex-col gap-4"
        >
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.href}
              to={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-300 ${
                  isActive ? "text-amber-400 font-bold" : "text-white/80 hover:text-amber-400"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-mobile-book-btn"
            className="mt-2 text-center bg-gradient-to-r from-amber-300 to-amber-600 text-black px-6 py-3 rounded-full text-xs font-bold uppercase tracking-[0.2em]"
          >
            Book Session
          </a>
        </div>
      )}
    </header>
  );
};
